export default "/directory/static/performs_religious.b116196f.svg";